import React, { Component } from 'react';
import styled from 'styled-components';

class Alert extends Component {
  constructor() {
    super();

    this.state = {
      hasKey: false
    };
  }
  componentDidMount() {
    const alertKey = window.localStorage.getItem(this.props.alertID);

    this.setState({
      hasKey: alertKey
    });
  }
  closeAlertForever() {
    window.localStorage.setItem(this.props.alertID, 'seen');
    this.setState({
      hasKey: true
    });
  }
  render() {
    if (!this.state.hasKey) {
      return (
        <Bubble alertID={this.props.alertID}>
          <CloseButton onClick={this.closeAlertForever.bind(this)}>
            {closeIcon}
          </CloseButton>
          <Message>
            <span
              dangerouslySetInnerHTML={{ __html: this.props.message.trim() }}
            />
          </Message>
        </Bubble>
      );
    }
    return <span />;
  }
}

export default Alert;

const Bubble = styled.div`
  position: fixed;
  padding: 1rem;
  bottom: 1rem;
  left: 1rem;
  background: #43cea2;
  background: linear-gradient(180deg, #185a9d, #43cea2 120%);
  z-index: 9999999999;
  width: 100%;
  max-width: 280px;
  border-radius: 8px;
  box-shadow: 0 5px 25px 5px rgba(0, 0, 0, 0.25);
  opacity: 0;
  transform: translateX(120%);
  transition: 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275) all;
  animation: showAlert 0.35s 4s ease both;
`;

const CloseButton = styled.button`
  outline: 0;
  padding: 0;
  margin: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  width: 1.125rem;
  height: 1.125rem;
  position: absolute;
  top: -0.35rem;
  right: -0.35rem;
  background-color: #fff;
  border-radius: 100%;
  line-height: 1;
  font-size: 0.5rem;
  transition: 0.15s ease all;

  &:hover {
    box-shadow: 0 0 0 2px #fff;
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 1em;
    height: 1em;
    pointer-events: none;
  }
`;

const Message = styled.p`
  font-size: 0.75rem;
  white-space: pre-line;
  color: #fff;
  line-height: 1.45;
  margin: 0;
`;

const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fill="#000"
      d="M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js